import { Chart } from "@/components/chart";
import { useResource } from "@/hooks/resources";

type SongPlay = { id: number, name: string, position: number, completions: number, plays: number }

type SongPlaysChartProps = {
  childId?: string | number;
  demo?: boolean;
};

export const SongPlaysChart = ({ childId, demo = false }: SongPlaysChartProps) => {
  const [songPlays] = useResource<Array<SongPlay>>(
    `/reports/song_plays?child_id=${childId}`
  );

  const demoSongPlays = [
    {
      "name": "Brown Bear",
      "completions": 4,
      "plays": 10
    },
    {
      "name": "My Head",
      "completions": 0,
      "plays": 3
    },
    {
      "name": "Lunch Song",
      "completions": 0,
      "plays": 5
    },
    {
      "name": "Pink Pig",
      "completions": 2,
      "plays": 8
    },
    {
      "name": "The Key",
      "completions": 1,
      "plays": 6
    },
    {
      "name": "Wow Song",
      "completions": 3,
      "plays": 12
    },
    {
      "name": "Let's Go Fast",
      "completions": 5,
      "plays": 15
    },
    {
      "name": "Sky and Pillow",
      "completions": 0,
      "plays": 4
    },
    {
      "name": "Hands and Fingers",
      "completions": 2,
      "plays": 9
    },
    {
      "name": "Cat and Dog",
      "completions": 4,
      "plays": 10
    },
    {
      "name": "Body Bottom",
      "completions": 1,
      "plays": 7
    },
    {
      "name": "Fruity Toot",
      "completions": 3,
      "plays": 11
    },
    {
      "name": "Wake Up Time",
      "completions": 6,
      "plays": 14
    },
    {
      "name": "Play Ball",
      "completions": 2,
      "plays": 8
    },
    {
      "name": "Body Top",
      "completions": 0,
      "plays": 2
    },
    {
      "name": "Garden Pig",
      "completions": 1,
      "plays": 5
    }
  ]

  return (
    <Chart
      options={{
        legend: {},
        tooltip: {
          trigger: "axis"
        },
        xAxis: {},
        yAxis: { name: "Song", type: "category" },
        series: [
          { type: "bar", name: "Started" },
          { type: "bar", name: "Completed" },
        ],
        dataset: {
          dimensions: ["name", "plays", "completions"],
          source: (demo ? demoSongPlays : songPlays || []).reverse()
        }
      }}
      className="h-[800px] p-4"
    />
  );
};
